import React from 'react';
import { Link } from 'react-router-dom';
import { Card } from '../ui/Card';
import { Badge } from '../ui/Badge';
import { CopyButton } from './CopyButton';
import { StatusBadge } from './StatusBadge';
import { ExternalLinkIcon, ShieldAlertIcon } from 'lucide-react';
interface Server {
  id: string;
  name: string;
  endpoint: string;
  status: 'healthy' | 'degraded' | 'offline';
  policyMode: string;
  allowedTools: number;
  lastActivity: string;
  blockedRequests24h: number;
}
interface ServerCardProps {
  server: Server;
}
export function ServerCard({
  server
}: ServerCardProps) {
  return <Card className="hover:border-slate-300 dark:hover:border-slate-600 transition-colors" data-id="element-65">
      <div className="flex items-start justify-between mb-3" data-id="element-66">
        <div data-id="element-67">
          <Link to={`/servers/${server.id}`} className="text-sm font-semibold text-slate-900 dark:text-slate-100 hover:text-blue-600 dark:hover:text-blue-400 transition-colors" data-id="element-68">
            {server.name}
          </Link>
          <div className="flex items-center gap-1 mt-0.5" data-id="element-69">
            <span className="text-xs font-mono text-slate-500 dark:text-slate-400" data-id="element-70">
              {server.id}
            </span>
            <CopyButton value={server.id} data-id="element-71" />
          </div>
        </div>
        <StatusBadge status={server.status} data-id="element-72" />
      </div>

      <div className="flex items-center gap-1 mb-3" data-id="element-73">
        <span className="text-xs font-mono text-slate-600 dark:text-slate-400 truncate flex-1" data-id="element-74">
          {server.endpoint}
        </span>
        <CopyButton value={server.endpoint} data-id="element-75" />
      </div>

      <div className="grid grid-cols-2 gap-3 text-xs" data-id="element-76">
        <div data-id="element-77">
          <span className="text-slate-500 dark:text-slate-400" data-id="element-78">Policy</span>
          <div className="mt-0.5" data-id="element-79">
            <Badge variant="neutral" data-id="element-80">{server.policyMode}</Badge>
          </div>
        </div>
        <div data-id="element-81">
          <span className="text-slate-500 dark:text-slate-400" data-id="element-82">
            Allowed Tools
          </span>
          <div className="mt-0.5 font-medium text-slate-900 dark:text-slate-100" data-id="element-83">
            {server.allowedTools}
          </div>
        </div>
        <div data-id="element-84">
          <span className="text-slate-500 dark:text-slate-400" data-id="element-85">
            Last Activity
          </span>
          <div className="mt-0.5 text-slate-700 dark:text-slate-300" data-id="element-86">
            {server.lastActivity}
          </div>
        </div>
        <div data-id="element-87">
          <span className="text-slate-500 dark:text-slate-400" data-id="element-88">
            Blocked (24h)
          </span>
          <div className="mt-0.5 flex items-center gap-1" data-id="element-89">
            {server.blockedRequests24h > 0 ? <>
                <ShieldAlertIcon className="h-3.5 w-3.5 text-red-500 dark:text-red-400" data-id="element-90" />
                <span className="font-medium text-red-600 dark:text-red-400" data-id="element-91">
                  {server.blockedRequests24h}
                </span>
              </> : <span className="text-slate-700 dark:text-slate-300" data-id="element-92">0</span>}
          </div>
        </div>
      </div>

      <div className="mt-4 pt-3 border-t border-slate-100 dark:border-slate-800" data-id="element-93">
        <Link to={`/servers/${server.id}`} className="text-xs font-medium text-blue-600 dark:text-blue-400 hover:text-blue-700 dark:hover:text-blue-300 flex items-center gap-1" data-id="element-94">
          View Details
          <ExternalLinkIcon className="h-3 w-3" data-id="element-95" />
        </Link>
      </div>
    </Card>;
}
export type { Server };